import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { credits } from './diagram';
import {FrontUserService} from '../../../../core/services/frontUsers.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'diagram',
    templateUrl: './diagram.component.html',
    styleUrls: ['./diagram.component.scss'],
    standalone: false
})
export class DiagramComponent implements OnChanges, OnInit {
  @Input() data;
  @Input() update;
  @Input() tgActive = '';
  @Input() allTG = '';

  public updateTime;
  public firstRun = true;
  public id;
  public fakeData = [ 2 , 5 , 7 , 3 , 2 , 5 , 6 , 7 , 8 , 4 , 2 , 4 , 5 , 7 , 4 , 1 , 3 , 5 , 6 , 4 , 5 ];
  public sum = 0;
  public chartType = 'doughnut';
  // public data: any = target.targetGroup;
  public credits = credits;
  public type = 'short';

  public chartData: Array<any> = [];

  public chartLabels: Array<any> = [];

  public chartColors: Array<any> = [
    {
      hoverBorderColor: [] ,
      hoverBorderWidth: 0 ,
      borderColor: '#007a7f' ,
      backgroundColor: [] ,
      borderWidth: 0,
      hoverBackgroundColor: []
    }
  ];

  public chartOptions: any = {
    responsive: true ,
    cutoutPercentage: '85'
  };
  public chartType2 = 'doughnut';

  public chartData2: Array<any> = [];

  public chartLabels2: Array<any> = [];

  public chartColors2: Array<any> = [
    {
      hoverBorderColor: [] ,
      hoverBorderWidth: 0 ,
      borderColor: '#007a7f' ,
      backgroundColor: [] ,
      hoverBackgroundColor: [],
      borderWidth: 0
    }
  ];

  public chartOptions2: any = {
    responsive: true ,
    cutoutPercentage: '70'
  };

  possibleData = [];
  lang;
  user;
  isOther = false;
  other = {
    count: 0,
    all: 0,
    possible: 0,
  };
  sumOfCredit = 0;
  public creditData = [];
  otherArray = [];
  constructor (public frontUserService: FrontUserService, private route: ActivatedRoute) {
  }

  public chartClicked2 (e: any): void {
  }

  public chartHovered2 (e: any): void {
  }

  public chartClicked (e: any): void {
  }

  public chartHovered (e: any): void {
  }

  confirm () {
  }

  ngOnChanges(changes) {
    if (!this.firstRun && this.update) {
      this.chartLabels.length = 0;
      this.chartLabels2.length = 0;
      this.chartData.length = 0;
      this.chartData2.length = 0;
      this.chartColors2[0].hoverBorderColor = [];
      this.chartColors2[0].backgroundColor = [];
      this.chartColors2[0].hoverBackgroundColor = [];

      this.chartColors[0].hoverBorderColor = [];
      this.chartColors[0].backgroundColor = [];
      this.chartColors[0].hoverBackgroundColor = [];

      if (this.tgActive !== 'all') {
        this.frontUserService.getRewards(this.id, this.tgActive).subscribe((res) => {
          this.init(res);
        });
      } else {
        this.frontUserService.getAllRewards(this.id, this.allTG).subscribe((res) => {
          this.init(res);
        });
      }

    }
  }

  ngOnInit () {
    if (this.data && this.data.subCredit && this.credits) {
      this.id = this.route.snapshot.queryParamMap.get('id');
      this.chartLabels.length = 0;
      this.chartLabels2.length = 0;
      this.chartData.length = 0;
      this.chartData2.length = 0;
      this.chartColors2[0].hoverBorderColor = [];
      this.chartColors2[0].backgroundColor = [];
      this.chartColors2[0].hoverBackgroundColor = [];

      this.chartColors[0].hoverBorderColor = [];
      this.chartColors[0].backgroundColor = [];
      this.chartColors[0].hoverBackgroundColor = [];
      if (this.tgActive !== 'all') {
        this.frontUserService.getRewards(this.id, this.tgActive).subscribe((res) => {
          this.init(res);
          this.firstRun = false;
        });
      } else {
        this.frontUserService.getAllRewards(this.id, this.allTG).subscribe((res) => {
          this.init(res);
          this.firstRun = false;
        });
      }
      // this.frontUserService.getRewards(this.id, '').subscribe((res) => {
      //   this.init(res);
      //   this.firstRun = false;
      // });
    }
  }

  init(res) {
    this.sum = 0;
    this.otherArray = [];
    this.sumOfCredit = 0;
    this.creditData = [];
    this.possibleData = [];
    const creditDataCopy = [];
    let sumOfRewards  = res.reward.reduce((a, b) => {
      if (b.eventType && b.eventType.name && b.eventType.name === 'Transfer' && this.tgActive === 'all') {
        if (b.credits < 0) {
          return parseInt(a, 10) + parseInt(b.credits, 10);
        } else {
          return parseInt(a, 10);
        }
      } else {
        return parseInt(a, 10) + parseInt(b.credits, 10);
      }
    }, 0);
    let sumOfPossible  = res.possible.reduce((a, b) => +a + +b.credits, 0);
    for (let i = 0; i < this.data.subCredit.length; i++) {
      this.sumOfCredit = this.sumOfCredit + this.data.subCredit[i].credit;

      const creditId = this.data.subCredit[i].eventTypeId;
      const creditObject = res.reward.find(
        item => item.eventTypeId === creditId
      );
      if (creditObject) {
        creditDataCopy.push(creditObject.credits);
        sumOfRewards = sumOfRewards - creditObject.credits;
      } else {
        creditDataCopy.push(0);
      }
      const possibleObject = res.possible.find(
        item => item.eventTypeId === creditId
      );
      if (possibleObject) {
        this.possibleData.push(possibleObject.credits);
        sumOfPossible = sumOfPossible - possibleObject.credits;
      } else {
        this.possibleData.push(0);
      }
      this.chartData.push(
        creditDataCopy[i]
      );
      this.chartData.push(
        this.data.subCredit[i].credit - creditDataCopy[i] < 0
          ? 0
          : this.data.subCredit[i].credit - creditDataCopy[i]
      );

      this.chartLabels.push(
        'Done on ' + this.data.subCredit[i].eventType.name
      );
      this.chartLabels.push(
        'Need on ' + this.data.subCredit[i].eventType.name
      );

      this.chartColors[0].hoverBorderColor.push('rgba(0, 0, 0, 0.1)');
      this.chartColors[0].hoverBorderColor.push('rgba(0, 0, 0, 0.1)');

      this.chartColors[0].backgroundColor.push(
        this.data.subCredit[i].eventType.color
      );
      this.chartColors[0].backgroundColor.push(
        this.hexToRgbA(this.data.subCredit[i].eventType.color)
      );

      this.chartColors[0].hoverBackgroundColor.push(
        this.data.subCredit[i].eventType.color
      );
      this.chartColors[0].hoverBackgroundColor.push(
        this.hexToRgbA(this.data.subCredit[i].eventType.color)
      );

      this.chartData2.push(
        creditDataCopy[i]
      );
      this.chartData2.push(
        this.data.subCredit[i].credit - creditDataCopy[i] < 0
          ? 0
          : this.data.subCredit[i].credit - creditDataCopy[i]
      );

      this.chartLabels2.push(this.data.subCredit[i].eventType.name);
      this.chartLabels2.push(this.data.subCredit[i].eventType.name);

      this.chartColors2[0].hoverBorderColor.push('rgba(255,255,255, 0.2)');
      this.chartColors2[0].hoverBorderColor.push('rgba(255,255,255, 0.4)');

      this.chartColors2[0].backgroundColor.push('rgba(255,255,255, 0.4)');
      this.chartColors2[0].backgroundColor.push('rgba(255,255,255, 0.2)');

      this.chartColors2[0].hoverBackgroundColor.push(
        'rgba(90,211,209, 0.2)'
      );
      this.chartColors2[0].hoverBackgroundColor.push(
        'rgba(90,211,209, 0.2)'
      );
      this.sum = this.sum + creditDataCopy[i];
    }
    const creditTarget = +this.data.creditTarget;
    if (creditTarget > +this.sumOfCredit) {

      this.chartData.push(creditTarget - this.sumOfCredit - sumOfRewards < 0 ? 0 : creditTarget - this.sumOfCredit - sumOfRewards);
      this.chartLabels.push('Need on ' + 'Other');

      this.chartColors[0].hoverBorderColor.push('rgba(0, 0, 0, 0.1)');


      this.chartColors[0].backgroundColor.push(this.hexToRgbA('#D3D3D3'));


      this.chartColors[0].hoverBackgroundColor.push(
        this.hexToRgbA('#D3D3D3')
      );


      this.chartData2.push(creditTarget - this.sumOfCredit - sumOfRewards < 0 ? 0 : creditTarget - this.sumOfCredit - sumOfRewards);


      this.chartLabels2.push('Need on ' + 'Other');


      this.chartColors2[0].hoverBorderColor.push('rgba(255,255,255, 0.4)');


      this.chartColors2[0].backgroundColor.push('rgba(255,255,255, 0.2)');


      this.chartColors2[0].hoverBackgroundColor.push(
        'rgba(90,211,209, 0.2)'
      );

      this.isOther = true;
      this.other = {
        count: sumOfRewards,
        all: creditTarget - this.sumOfCredit,
        possible: sumOfPossible
      };

    } else {
      this.isOther = false;
    }

    for (let k = 0; k < res.reward.length; k++) {
      if (this.tgActive === 'all' && res.reward[k].eventType && res.reward[k].eventType.name === 'Transfer'
        && res.reward[k].credits > 0) {
        continue;
      }
      const creditObject = this.data.subCredit.find(
        item => item.eventTypeId === res.reward[k].eventTypeId
      );
      if (!creditObject) {
        this.otherArray.push( {credits: res.reward[k].credits, eventType: res.reward[k].eventType });
        this.chartData.push(res.reward[k].credits < 0 ? 0 : res.reward[k].credits);

        if (res.reward[k].eventType && res.reward[k].eventType.name) {
          this.chartLabels.push('Done on ' + res.reward[k].eventType.name);
        } else {
          this.chartLabels.push('Done on ');
        }

        this.chartColors[0].hoverBorderColor.push('rgba(0, 0, 0, 0.1)');

        if (res.reward[k].eventType && res.reward[k].eventType.color) {
          this.chartColors[0].backgroundColor.push(res.reward[k].eventType.color);
          this.chartColors[0].hoverBackgroundColor.push(res.reward[k].eventType.color);
        } else {
          this.chartColors[0].backgroundColor.push('');
          this.chartColors[0].hoverBackgroundColor.push('');
        }

        this.chartData2.push(res.reward[k].credits < 0 ? 0 : res.reward[k].credits);

        if (res.reward[k].eventType && res.reward[k].eventType.name) {
          this.chartLabels2.push('Done on ' +  res.reward[k].eventType.name);
        } else {
          this.chartLabels2.push('Done on ');
        }


        this.chartColors2[0].hoverBorderColor.push('rgba(255,255,255, 0.2)');


        this.chartColors2[0].backgroundColor.push('rgba(255,255,255, 0.4)');


        this.chartColors2[0].hoverBackgroundColor.push(
          'rgba(90,211,209, 0.2)'
        );
        this.isOther = true;
        if (res.reward[k].eventType && res.reward[k].eventType.name
          && res.reward[k].eventType.name === 'Transfer' && this.tgActive === 'all') {
          if (res.reward[k].credits < 0) {
            this.sum = this.sum + res.reward[k].credits;
          }
        } else {
          this.sum = this.sum + res.reward[k].credits;
        }
      }
    }

    this.creditData = creditDataCopy;
  }

  hexToRgbA (hex) {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [ c[ 0 ] , c[ 0 ] , c[ 1 ] , c[ 1 ] , c[ 2 ] , c[ 2 ] ];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [ (c >> 16) & 255 , (c >> 8) & 255 , c & 255 ].join(',') + ',0.4)';
    }
    throw new Error('Bad Hex');
  }
}
